import { z } from 'zod';

export type Result<E, D> = { kind: 'Ok'; data: D } | { kind: 'Ko'; error: E };

export type DataStatus = 'Init' | 'Fetching' | 'Submitting' | 'Submitted';

export enum ItemTab {
  INFO = 0,
  ORDER = 1,
  SELLER = 2,
  BUYER = 3,
  HISTO = 4,
  RETURN_STATUS = 5,
}

export enum ClientTab {
  BOUGHT = 0,
  SOLD = 1,
  LISTED = 2,
  OTHERS = 3,
}

export enum ShippingTypeId {
  STANDARD = 1,
  DIRECT = 2,
}

export enum CustomerType {
  C2C = 'C2C',
  B2C = 'B2C',
}

export enum FlagId {
  AI_LISTING = '62',
  RETURN_TO_SELLER = '36',
  RETURN_TO_WAREHOUSE = '37',
}

export const UploadDocumentPermissionSchema = z.object({
  canEdit: z.boolean(),
});
export type UploadDocumentPermission = z.infer<typeof UploadDocumentPermissionSchema>;

export const DocumentSchema = z.object({
  documentUrl: z.string(),
});
export type Document = z.infer<typeof DocumentSchema>;

export const DsaReportSchema = z.object({
  idTicket: z.number().nullable().optional(),
  datetimeReportCreatedUtc: z.string().nullable().optional(),
  datetimeDecisionUtc: z.string().nullable().optional(),
  idProductReported: z.number().nullable().optional(),
  idCustomerReported: z.number().nullable().optional(),
  reportReason: z.string().nullable().optional(),
  reportDecision: z.string().nullable().optional(),
});
export type DsaReport = z.infer<typeof DsaReportSchema>;
